import { is } from '@easeltv/utilities';

import {
    ConsoleDriverConfig,
    DriverConfig,
    SentryDriverConfig,
} from '../drivers';

/**
 * isConsoleDriverConfig
 *
 * Type guard for the ConsoleDriverConfig type
 *
 * @param x an unknown to be tested for ConsoleDriverConfig type
 */
export const isConsoleDriverConfig = (x: unknown): x is ConsoleDriverConfig =>
    is.object(x) && x.type === 'console';

/**
 * isSentryDriverConfig
 *
 * Type guard for the SentryDriverConfig type
 *
 * @param x an unknown to be tested for SentryDriverConfig type
 */
export const isSentryDriverConfig = (x: unknown): x is SentryDriverConfig =>
    is.object(x) &&
    x.type === 'sentry' &&
    is.string(x.dsn) &&
    is.string(x.release) &&
    is.string(x.environment) &&
    is.string(x.tenant);

/**
 * isDriverConfig
 *
 * Type guard for the DriverConfig type
 *
 * @param x an unknown to be tested for DriverConfig type
 */
export const isDriverConfig = (x: unknown): x is DriverConfig =>
    isConsoleDriverConfig(x) || isSentryDriverConfig(x);
